(() => {
  if (customElements.get('fudge-standing-desk')) return;

  customElements.define('fudge-standing-desk', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.category = this.querySelector('[data-ah-category]');
      this.sort = this.querySelector('[data-ah-sort]');
      this.form = this.querySelector('.ah-sd-toolbar');
      if (!this.category || !this.sort || !this.form) return;
      this.categoryOptions = Array.from(this.category.querySelectorAll('[role="menuitemradio"]'));
      this.sortOptions = Array.from(this.sort.querySelectorAll('[role="menuitemradio"]'));
      this.menus = [this.category, this.sort];
      this.cards = Array.from(this.querySelectorAll('.fudge-pg-card'));
      this.status = this.querySelector('[data-ah-status]');
      this.empty = this.querySelector('[data-ah-empty]');
      this.events = new AbortController();
      const options = { signal: this.events.signal };

      this.bindMenu(this.category, this.categoryOptions, option => this.changeCategory(option.dataset.categoryValue), options);
      this.bindMenu(this.sort, this.sortOptions, option => this.changeSort(option.dataset.sortValue), options);
      const closeOutside = event => this.menus.forEach(menu => {
        if (!menu.contains(event.target)) menu.open = false;
      });
      document.addEventListener('click', closeOutside, options);
      document.addEventListener('focusin', closeOutside, options);
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        this.changeSort(this.sort.dataset.sortValue);
      }, options);
      window.addEventListener('popstate', () => this.restoreCategory(), options);
      window.addEventListener('pageshow', () => this.restoreCategory(), options);
      this.restoreCategory();
      // Resolve old Featured URLs through Shopify so Bestselling reflects real ranking.
      if (!this.sortOptions.some(option => option.dataset.sortValue === this.sort.dataset.sortValue) && !window.Shopify?.designMode) {
        window.location.replace(this.sortOptions[0].href);
      }
    }

    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
    }

    bindMenu(menu, choices, select, options) {
      const trigger = menu.querySelector('summary');
      menu.addEventListener('toggle', () => {
        trigger.setAttribute('aria-expanded', String(menu.open));
        if (menu.open) this.menus.forEach(other => { if (other !== menu) other.open = false; });
        const current = choices.includes(document.activeElement) ? document.activeElement : choices.find(option => option.getAttribute('aria-checked') === 'true') || choices[0];
        choices.forEach(option => { option.tabIndex = menu.open && option === current ? 0 : -1; });
      }, options);
      choices.forEach(option => option.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        select(option);
      }, options));
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          menu.open = false;
          trigger.focus();
          event.preventDefault();
          return;
        }
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End', ' '].includes(event.key)) return;
        const index = choices.indexOf(document.activeElement);
        if (event.key === ' ') {
          if (index >= 0) {
            event.preventDefault();
            select(choices[index]);
          }
          return;
        }
        event.preventDefault();
        menu.open = true;
        let next = index;
        if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = choices.length - 1;
        else if (index < 0) next = event.key === 'ArrowUp' ? choices.length - 1 : 0;
        else next = (index + (event.key === 'ArrowDown' ? 1 : -1) + choices.length) % choices.length;
        choices.forEach((option, i) => { option.tabIndex = i === next ? 0 : -1; });
        choices[next].focus();
      }, options);
    }

    restoreCategory() {
      const value = new URL(window.location.href).searchParams.get('ah_category') || 'all';
      this.categoryValue = this.categoryOptions.some(option => option.dataset.categoryValue === value) ? value : 'all';
      this.applyCategory(this.categoryValue !== 'all');
      this.menus.forEach(menu => {
        menu.open = false;
        menu.querySelector('summary').setAttribute('aria-expanded', 'false');
      });
      this.updateMenuLinks();
    }

    changeCategory(value) {
      if (!this.categoryOptions.some(option => option.dataset.categoryValue === value)) return;
      this.categoryValue = value;
      this.applyCategory(true);
      const url = new URL(window.location.href);
      if (value === 'all') url.searchParams.delete('ah_category');
      else url.searchParams.set('ah_category', value);
      window.history.replaceState(window.history.state, '', url);
      this.updateMenuLinks();
      this.category.open = false;
      this.category.querySelector('summary').focus();
    }

    applyCategory(announce) {
      const selected = this.categoryOptions.find(option => option.dataset.categoryValue === this.categoryValue);
      this.categoryOptions.forEach(option => option.setAttribute('aria-checked', String(option === selected)));
      const trigger = this.category.querySelector('summary');
      const label = this.categoryValue === 'all' ? 'Category' : selected.textContent.trim();
      trigger.textContent = label;
      trigger.setAttribute('aria-label', `Filter by: ${label}`);
      let count = 0;
      this.cards.forEach(card => {
        card.hidden = this.categoryValue !== 'all' && card.dataset.ahCategory !== this.categoryValue;
        if (!card.hidden) count += 1;
      });
      this.empty.hidden = count !== 0;
      this.status.textContent = announce ? `${count} ${count === 1 ? 'desk' : 'desks'} shown.` : '';
    }

    updateMenuLinks() {
      this.sortOptions.forEach(option => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', option.dataset.sortValue);
        url.searchParams.delete('page');
        option.href = url.href;
      });
      this.categoryOptions.forEach(option => {
        const url = new URL(window.location.href);
        if (option.dataset.categoryValue === 'all') url.searchParams.delete('ah_category');
        else url.searchParams.set('ah_category', option.dataset.categoryValue);
        option.href = url.href;
      });
    }

    changeSort(value) {
      const option = this.sortOptions.find(option => option.dataset.sortValue === value);
      if (!option) return;
      this.sort.open = false;
      if (option.href !== window.location.href) window.location.assign(option.href);
    }
  });
})();
